import { t } from 'i18next';

import { UserByRequestResponse } from '../../../../../typings/api/skymap/rest/v0/user';
// @ts-expect-error JSON import
import roleSettings from '../../../../static/configuration/roleSettings.json';
import { assertNever } from '../../../utils/variables';

export interface NavigationItem {
  id: string;
  index: number;
  title: string;
}

type Role = 'user' | 'companyAdmin' | 'organizationAdmin';

function resolveTitle(role: Role): string {
  switch (role) {
    case 'user':
      return t('roles.user', { ns: 'common' });
    case 'companyAdmin':
      return t('roles.companyAdmin', { ns: 'common' });
    case 'organizationAdmin':
      return t('roles.organizationAdmin', { ns: 'common' });
    default:
      assertNever(role);
  }
}

/**
 * Computes navigation items from user without mutating the user.
 * Replaces UserStore.getNavigationItems for React.
 */
export function getNavigationItemsFromUser(
  user: UserByRequestResponse['data'] | undefined,
): NavigationItem[] {
  if (!user) {
    return [];
  }

  const roles: Role[] = [];
  if (user.isOrganizationAdmin) {
    roles.push('organizationAdmin');
  } else if ((user.companyusers ?? []).length > 0) {
    roles.push('companyAdmin');
    if ((user.projects ?? []).length > 0) {
      roles.push('user');
    }
  } else {
    roles.push('user');
  }

  const tmpNavItems: Record<string, NavigationItem> = {};
  for (const role of roles) {
    const settings = (roleSettings as Record<string, { id: string; index: number }[]>)[role];
    if (!settings) {
      continue;
    }
    for (const setting of settings) {
      tmpNavItems[setting.id] = {
        ...setting,
        title: resolveTitle(role),
      };
    }
  }
  return Object.values(tmpNavItems);
}
